import React, { useState } from "react";
import { Box, Stack, StackRow, Label, Select, Autocomplete } from "codekit";
import { Controller } from "react-hook-form";
import { useGetClientGraphicByIdMutation } from "../../../../../libs/redux/slices/Reportxx/Repfinac/repfinacApiSlice";

/**
 * Fila de filtros jerárquicos del monitor de entrega urgente
 * @author Oscar Rosero <oscar.rosero@repremundo.com.co>
 * @since 2026-05-01
 * @param {object} control - react-hook-form control
 * @param {Array<{ value: string, text: string }>} gerencias
 * @param {Array<{ value: string, text: string }>} grupos
 * @param {string} gerenciaValue - valor actual de gerencia para deshabilitar el grupo
 */
const Filtrows = ({ control, gerencias, grupos, gerenciaValue }) => {
  // Autocomplete cliente
  const [resultsClient, setResultsClient] = useState([]);
  const [getClientById] = useGetClientGraphicByIdMutation();

  /**
   * Busca clientes perfilados para el autocomplete
   * @param {string} CLIIDXXX
   * @param {Function} cb
   */
  const searchClient = async (CLIIDXXX, cb) => {
    return await getClientById({ filters: { CLIIDXXX } })
      .unwrap()
      .then((res) => setResultsClient(res.data))
      .catch(() => {})
      .finally(() => cb());
  };
  return (
    <Box mb={8} borderBottom={1} spacing={2}>
      <Stack gap={3} columnsVariant="form-3">
        <StackRow>
          <Label>Gerencia</Label>
          <Controller
            control={control}
            name="GERENCIA"
            render={({ field: { onChange, value } }) => (
              <Select
                value={value}
                options={[
                  { text: "Todas las gerencias", value: "" },
                  ...gerencias.map((g) => ({ text: g.text, value: g.value })),
                ]}
                onChangeValue={(ctx) => onChange(ctx.option.value)}
              />
            )}
          />
        </StackRow>
        <StackRow>
          <Label>Grupo de Gestión</Label>
          <Controller
            control={control}
            name="GRUPO"
            render={({ field: { onChange, value } }) => (
              <Select
                value={value}
                disabled={!gerenciaValue}
                options={[
                  {
                    text: !gerenciaValue ? "Seleccione una gerencia primero" : "Todos los grupos",
                    value: "",
                  },
                  ...grupos.map((g) => ({ text: g.text, value: g.value })),
                ]}
                onChangeValue={(ctx) => onChange(ctx.option.value)}
              />
            )}
          />
        </StackRow>
        <StackRow>
          <Label>Cliente</Label>
          <Controller
            control={control}
            name="CLIENTE"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                placeholder="Buscar..."
                textLoading="Buscando..."
                textNoResults="No se encontraron registros"
                minLengthToSearch={2}
                selected={value}
                searchResults={resultsClient}
                onChangeSearch={(val, cb) => searchClient(val, cb)}
                onItemClick={(ctx) => onChange(`${ctx.item.label}`)}
                onResetSelected={() => onChange("")}
              />
            )}
          />
        </StackRow>
      </Stack>
    </Box>
  );
};

export default Filtrows;
